import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/ironwood-logo.svg'


const _hoisted_1 = {
  class: "navbar navbar-expand-lg navbar-light fixed-top",
  id: "mainNav"
}
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = {
  class: "navbar-toggler navbar-toggler-right",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarResponsive",
  "aria-controls": "navbarResponsive",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarResponsive"
}
const _hoisted_5 = { class: "navbar-nav ms-auto" }
const _hoisted_6 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("a", { href: "/" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Ironwood Logo",
          class: "mx-2",
          style: {"padding-bottom":"5px","padding-right":"1.5em","height":"2em","filter":"invert(79%) sepia(38%) saturate(4886%) hue-rotate(2deg)\n              brightness(107%) contrast(95%)"}
        })
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("a", {
        class: "navbar-brand",
        href: "/"
      }, "ironwood flutes", -1)),
      _createElementVNode("button", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-bars" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _cache[1] || (_cache[1] = _createStaticVNode("<li class=\"nav-item\"><a class=\"nav-link\" href=\"/flutes\">flutes</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/headjoints\">headjoints</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/whistles\">whistles</a></li>", 3)),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/custom"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("custom", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("li", { class: "nav-item" }, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "/#about"
            }, "about")
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("li", { class: "nav-item" }, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "/#contact"
            }, "contact")
          ], -1))
        ])
      ])
    ])
  ]))
}